import React from "react";

export default function CivWinRate({ civilization, wins, looses }) {
  return (
    <article className="civ-win-rate">
      <div className="civ-win-rate-image">
        <img
          src={`./civs/${civilization}.png`}
          alt={civilization}
          title={civilization}
        />
      </div>
      <div className="civ-win-rate-stats">
        <p>⚔️ {wins}</p>
        <p>💀 {looses}</p>
      </div>
    </article>
  );
}
